module.exports = __webpack_public_path__ + "static/media/ometa.9c44589d.png";